import { localStorage } from "@jog/shared"
import { useRouter } from "next/router"
import { useEffect } from "react"

interface AwinState {
    awc: string
    t: number
}

export const useAwin = () => {
    const router = useRouter()
    useEffect(() => {
        if (router.isReady) {
            const awc = router.query.awc as string
            if (awc) {
                const t = new Date().getTime()
                localStorage.setItem<AwinState>("awin_awc", { awc, t })
            }
        }
    }, [router.isReady, router.query.awc])
}

export const getAwinAwc = () => {
    try {
        const data = localStorage.getItem<AwinState>("awin_awc")
        if (!data) return
        const now = new Date().getTime()
        if (now - data.t > 1000 * 60 * 60 * 24 * 30) {
            localStorage.removeItem("awin_awc")
            return
        }
        const newClient = (document.cookie
            .split(";")
            .find((i) => i.includes("NewClient"))
            ?.trim()
            .split("=")[1] || "new") as "new" | "existing"
        return { awc: data.awc, newClient }
    } catch (e) {
        console.error(e)
        return
    }
}
